module.exports = __webpack_public_path__ + "img/logo2_suzhou.7dd68d5e.svg";